'use client';

import { LinkButton } from '@/src/shared/presentation/components/link-button';

import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './promoted-block-view.css';

import type { PromotedBlockViewModel } from '../../view-models/blocks/promoted-block.viewModel';

export function PromotedBlockView({ hide, title, subtitle, body, button }: PromotedBlockViewModel) {
  return hide ? null : (
    <CMSBlockWrapper contentClassName={css.content}>
      <h2 className={css.title}>{title}</h2>
      {subtitle && <h3 className={css.subtitle}>{subtitle}</h3>}
      {body && <div className={css.body} dangerouslySetInnerHTML={{ __html: body.processed }} />}

      {button && (
        <LinkButton
          href={button.uri}
          title={button.title}
          target={button.target}
          className={css.button}
        >
          {button.title}
        </LinkButton>
      )}
    </CMSBlockWrapper>
  );
}
